var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content-box"},[_c('div',{staticClass:"left-box"},[_c('ProductCom')],1),_c('div',{staticClass:"center-box"},[_c('div',{staticClass:"center-default-box"},[_c('CenterCom')],1)]),_c('div',{staticClass:"right-box"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }